export class NomsHardman {


    public static readonly NOTREADY = "routeNotReady";
    public static readonly PROBLEM = "routeWithProblem";
    public static readonly DELAYED = "routeDelayed";

}